// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingMenu_root__36N-7","content":"LandingMenu_content__2D9Kz","button":"LandingMenu_button__qVXLK"};